import React, { Component } from "react";
import NewsPost from '../NewsPost';
import CrudButton from '../CrudButton';
import AddPostModal from '../AddPostModal';
import InstagramPost from "../InstagramPost";
import { AuthContext } from '../AuthContext';
import { ModalContext } from '../ModalContext';
import axios from 'axios';
import soccerMaxBanner from '../../assets/images/soccermaxx_banner.png';
import sickKidsBanner from '../../assets/images/sickkids_banner.jpeg';
import marchBreak2026Banner from '../../assets/images/caq_march_break_poster_2026.jpg';
import downloadsPageStyles from '../../styles/DownloadsPage.module.css';

class HomePage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            newsPosts: [],
            instagramPosts: []
        }
    }

    componentDidMount() {
        axios.get('/api/newsposts')
        .then(resp => {
            const success = resp.data.success;
            if (success) {
                this.setState({
                    newsPosts: resp.data.data
                });
            } else {
                return;
            }
        })
        .catch(error => {
            console.log(error);
        });

        axios.get('/api/instagram/posts')
        .then(resp => {
            const success = resp.data.success;
            if (success) {
                this.setState({
                    instagramPosts: resp.data.instagram_posts
                });
            } else {
                console.log("Instagram posts error");
                return;
            }
        })
        .catch(error => {
            console.log(error);
        });
    }



    render() {
        const manualNewsPostText = <><p>The program focuses on good ball skills, physical conditioning and shooting. This program is taught in an enthusiastic environment. Let CAQ Soccer Training help your child reach his or her maximum soccer potential.</p>
        <br />
        <p><u>Dates and locations for the Fall Training Sessions for players 9,10,11</u></p>
        <p><b>Tuesday Sessions:</b> 5 weeks - October 7, 21 Nov 4, Dec 2, 16</p>
        <p><b>Location:</b> AC Sportsplex 11030 Highway 27</p>
        <p><b>Time:</b> 7:30 &ndash; 8:30</p>
        <p><b>Cost:</b> $175.00 pls HST - $197.75</p>
        <p><u>Dates and locations for the Fall Training Sessions for Players 12,13,14</u></p>
        <p><b>Tuesday Sessions:</b> 5 weeks - October 14, 28 Nov 11, 25, Dec 9</p>
        <p><b>Location:</b> AC Sportsplex 11030 Highway 27</p>
        <p><b>Time:</b> 7:30 &ndash; 8:30</p>
        <p><b>Cost:</b> $175.00 plus HST - $197.75</p></>
        
        const crudButtonStyles = {
            position: "absolute",
            top: "32px",
            right: "20px"
        }

        return (
            <AuthContext.Consumer>
                {({isAuth}) => (
                    <ModalContext.Consumer>
                        {({setShowModal, setModalChildComponent}) => (
                            <div className="landingPage">
                                <div className="splashImage">
                                    <div className="splashText">Play through passion.</div>
                                </div>
                                <div className="instagramPosts">
                                    {this.state.instagramPosts.map(instagramPost => {
                                        return (<InstagramPost key={instagramPost.id} media_type={instagramPost.media_type} media_url={instagramPost.media_url} />)
                                    })}
                                </div>
                                <div className="pageContent column">
                                    <div className="leftSection">
                                        <div className="contentHeader">Latest news</div>
                                        {isAuth &&
                                        <CrudButton classNames={["green"]} style={crudButtonStyles} onClick={() => {
                                            setModalChildComponent(<AddPostModal />);
                                            setShowModal(true);
                                        }}>Add Post</CrudButton>
                                        }
                                        <div className="newsPosts">
                                        <NewsPost key={"2343456"} id={2343456} title={"2026 March Break Soccer Camp"} createdAtDate={"2026-02-10"} imageUrl={marchBreak2026Banner} imageAspectRatio={0.8} authenticated={false}>{
                                            <a href="/files/caq_2026_march_break_registration_form.doc" download>
                                                <div className={downloadsPageStyles.downloadItem}>
                                                    Registration Form
                                                </div>
                                            </a>
                                        }</NewsPost>
                                        <NewsPost key={"23434"} id={23434} title={"Improve your skills with the Elite training sessions offered by CAQ Soccer Training."} createdAtDate={"2025-10-20"} imageUrl={null} authenticated={false}>{manualNewsPostText}</NewsPost>
                                        {this.state.newsPosts.map(newsPost => {
                                            return (<NewsPost key={newsPost.id} id={newsPost.id} title={newsPost.title} createdAtDate={newsPost.createdAt} imageUrl={newsPost.image_url} authenticated={isAuth}>{newsPost.content}</NewsPost>)
                                        })}
                                        </div>
                                    </div>
                                    <div className="rightSection">
                                        <div className="rightSectionItem">
                                            <div className="itemTitle">Training Video</div>
                                            <div className="trainingVideo">
                                                <iframe width="250" height="250"
                                                    src="https://www.youtube.com/embed/8eT1NQy1rA4" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
                                                </iframe>
                                            </div>
                                        </div>
                                        {/* Social Media */}
                                        <div className="rightSectionItem">
                                            <div className="itemTitle">Social Media</div>
                                            <div className="socialMediaRow">
                                                <div className="socialMediaIcon instagram"></div>
                                                <a href="https://www.instagram.com/c.a.q.soccer/?utm_source=ig_embed&ig_rid=598db039-58c7-4d00-a74c-27134ca291fa" target="_blank" rel="noreferrer"><div className="socialMediaText">@c.a.q.soccer</div></a>
                                            </div>
                                            <div className="socialMediaRow">
                                                <div className="socialMediaIcon facebook"></div>
                                                <a href="https://www.facebook.com/Caqsoccer/" target="_blank" rel="noreferrer"><div className="socialMediaText">@Caqsoccer</div></a>
                                            </div>
                                        </div>
                                        {/* Sponsors */}
                                        {/* <div className="rightSectionItem">
                                            <div className="itemTitle">Sponsorships</div>
                                            <img className="sponsorBanner soccerMaxx" src={soccerMaxBanner} alt="SoccerMaxx Banner" />
                                            <img className="sponsorBanner sickKids" src={sickKidsBanner} alt="SickKids Banner" />
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        )}
                    </ModalContext.Consumer>
                )}
            </AuthContext.Consumer>
        );
    }
};

export default HomePage;